<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/employee/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xingming')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zhiwei')">
            <el-select v-model="yt.conditions.posId" filterable placeholder="请选择职位">
              <el-option v-for="item in positionList" :key="item.id" :label="item.posName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('gonghao')">
            <el-input v-model="yt.conditions.jobNo"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_employment_management_employee_create')">
          {{ $t('xinzeng') }}
        </el-button>

        <el-button size="mini" v-if="utils.checkPower('web_employment_management_employee_sync')" @click="syncAllEmployee()">
          {{ $t('全量同步') }}
        </el-button>

        <el-button size="mini" v-if="utils.checkPower('web_employment_management_employee_import')" type="primary" @click="yt.showEditDialog('daoru', null, 'w2')">
          {{ $t('daoru') }}
        </el-button>
        <el-button size="mini" type="primary" @click="importShow = !importShow" v-if="utils.checkPower('web_employment_management_employee_batchImportSkill')">
          {{ $t('daorujinengrenzheng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xiangqing', scope.row, 'w1');
            afterShow(scope.row);
          "
          type="text"
        >
          {{ $t('xiangqing') }}
        </el-button>

        <el-button size="mini" @click="yt.showEditDialog('bianji', scope.row, 'w1')" type="text">
          {{ $t('bianji') }}
        </el-button>
      </template>
    </yi_curd_table>

    <el-dialog :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" width="60%" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :model="form" label-width="120px" class="form" size="mini">
          <div class="dialog-scroller">
            <el-row>
              <!-- 基本信息 -->
              <el-col :span="12">
                <el-form-item :label="$t('gonghao')" required>
                  <el-input v-model="form.jobNo"></el-input>
                </el-form-item>
                <el-form-item :label="$t('xingming')" required>
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('suosuzuzhi')" required>
                  <yi_data_select :type="'organization'" :ids.sync="form.orgId"></yi_data_select>
                </el-form-item>
                <el-form-item :label="$t('zhiwei')">
                  <el-select v-model="form.posId" filterable placeholder="请选择职位">
                    <el-option v-for="item in positionList" :key="item.id" :label="item.posName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('minzu')">
                  <yi_dictionary_select :max="1" :type="'HR_NATION'" :ids.sync="yt.editObj.nation"> </yi_dictionary_select>
                </el-form-item>
                <el-row>
                  <el-col :span="14">
                    <el-form-item :label="$t('ruzhishijian')">
                      <el-date-picker v-model="form.entryTime" type="datetime" placeholder="选择日期时间" @change="calculateWorkAge(form.entryTime)"></el-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10">
                    <el-form-item :label="$t('gongling')">
                      {{ calculateWorkAge(form.entryTime) }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 右侧头像 -->
              <el-col :span="12" class="avatar-section">
                <el-upload :show-file-list="false" :action="domain" :headers="headers" list-type="picture-card" :name="'files'" :on-change="onchange" :before-upload="beforeUpload" :on-success="handleOnSuccess" :on-progress="handleOnProgress" :on-error="handleOnError" :multiple="false">
                  <img v-if="imageUrl" :src="imageUrl" style="width: 100%; height: 100%;" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="14">
                    <el-form-item :label="$t('chushengriqi')">
                      <el-date-picker v-model="form.birthday" type="date" placeholder="选择日期" @change="calculateAge(form.birthday)"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item :label="$t('nianling')">
                      {{ calculateAge(form.birthday) }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-form-item :label="$t('sex')" required>
              <el-radio-group v-model="form.sex">
                <el-radio label="1">男</el-radio>
                <el-radio label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 联系信息 -->
            <el-row>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="form.remake" type="textarea"></el-input>
              </el-form-item>
            </el-row>

            <el-row :span="24">
              <el-col :span="8">
                <el-form-item :label="$t('shoujihao')">
                  <el-input v-model="form.callPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('weixinhao')">
                  <el-input v-model="form.vxNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Email">
                  <el-input v-model="form.emall"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('address')">
              <el-input v-model="form.address" type="textarea"></el-input>
            </el-form-item>

            <el-form-item :label="$t('zhuanghuxuanxiang')">
              <el-radio-group v-model="form.accountOption">
                <el-radio label="sync">同步创建用户账号</el-radio>
                <el-radio label="link">关联现有用户账号</el-radio>
                <el-radio label="none">暂不关联账户</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="form.accountOption === 'sync'">
              <el-row :span="24">
                <el-col :span="8">
                  <el-form-item :label="$t('yonghuzhanghao')" required>
                    <el-input style="width: 100px;" :placeholder="$t('qingshuruneirong')" v-model="form.accountName">
                      <template slot="prepend"
                        >{{ store.state.customer.code }}_</template
                      >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('juese')">
                    <yi_data_select :type="'customerRole'" :ids.sync="form.roleIds" multiple></yi_data_select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('shifouqiyong')">
                    <el-switch v-model="form.isEnabled" disabled></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>

            <template v-if="form.accountOption === 'link'">
              <el-form-item :label="$t('guanlianzhanghu')">
                <yi_data_select :type="'customer_user'" :ids.sync="form.userId"></yi_data_select>
              </el-form-item>
            </template>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="saveData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action === 'xiangqing'">
        <!-- 详情信息 -->
        <el-row :gutter="20" class="detail-info">
          <el-col :span="18">
            <el-row style="margin-bottom: 40px;">
              <el-col :span="6">
                <p>
                  <strong>{{ $t('xingming') }}：</strong>{{ yt.editObj.name }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>
                  <strong>{{ $t('gonghao') }}：</strong>{{ yt.editObj.jobNo }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>
                  <strong>{{ $t('sex') }}：</strong>{{ yt.editObj.sex ? (yt.editObj.sex === 1 ? '男' : '女') : '未知' }}
                </p>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <p>
                  <strong>{{ $t('suoshuzuzhi') }}：</strong>{{ yt.editObj.org ? yt.editObj.org.name : '' }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>
                  <strong>{{ $t('zhiwei') }}：</strong>{{ yt.editObj.pos ? yt.editObj.pos.posName : '' }}
                </p>
              </el-col>
              <el-col :span="6">
                <p>
                  <strong>{{ $t('status') }}：</strong>{{ yt.editObj.dtStatus ? (yt.editObj.dtStatus === 1 ? '在职' : '离职') : '' }}
                </p>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" class="avatar-section">
            <img v-if="imageUrl" :src="imageUrl" fit="cover" class="avatar" />
            <img v-else src="../../../../assets/img/account/avatar.png" class="avatar" />
          </el-col>
        </el-row>

        <!-- 标签页 -->
        <el-tabs v-model="activeTab" style="margin-bottom: 20px;">
          <el-tab-pane label="资质认证" name="qualification">
            <div class="tab-content dialog-scroller">
              <qualificationTable v-if="activeTab === 'qualification'" :employeeId="yt.editObj.id"></qualificationTable>
            </div>
          </el-tab-pane>
          <el-tab-pane label="技能认证" name="skills">
            <div class="tab-content dialog-scroller">
              <certificationTable v-if="activeTab === 'skills'" :employee="yt.editObj"></certificationTable>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资源分配" name="resources">
            <div class="tab-content dialog-scroller">
              <resourceTable v-if="activeTab === 'resources'" :employee="yt.editObj"></resourceTable>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>

      <template v-if="yt.editObj.action === 'bianji'">
        <el-form :model="form" label-width="120px" class="form" size="mini">
          <div class="dialog-scroller">
            <el-row>
              <!-- 基本信息 -->
              <el-col :span="16">
                <el-row>
                  <el-col :span="12">
                    <el-form-item :label="$t('gonghao')" required>
                      <el-input v-model="yt.editObj.jobNo"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('xingming')" required>
                      <el-input v-model="yt.editObj.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item :label="$t('suoshuzuzhi')" required>
                      <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('zhiwei')">
                      <el-select v-model="yt.editObj.posId" filterable placeholder="请选择职位">
                        <el-option v-for="item in positionList" :key="item.id" :label="item.posName" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="14">
                    <el-form-item :label="$t('ruzhishijian')">
                      <el-date-picker v-model="yt.editObj.entryTime" type="datetime" placeholder="选择日期时间" @change="calculateWorkAge(form.entryTime)"></el-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="5">
                    <el-form-item :label="$t('gongling')">
                      {{ calculateWorkAge(yt.editObj.entryTime) }}
                    </el-form-item>
                  </el-col>

                  <el-col :span="5">
                    <el-form-item :label="$t('sex')">
                      男
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 右侧头像 -->
              <el-col :span="8" class="avatar-section">
                <el-upload :show-file-list="false" :action="domain" :headers="headers" list-type="picture-card" :name="'files'" :on-change="onchange" :before-upload="beforeUpload" :on-success="handleOnSuccess" :on-progress="handleOnProgress" :on-error="handleOnError" :multiple="false">
                  <img v-if="imageUrl" :src="imageUrl" style="width: 100%; height: 100%;" />
                  <img v-else src="../../../../assets/img/account/avatar.png" style="width: 100%; height: 100%;" />
                </el-upload>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="14">
                    <el-form-item :label="$t('chushengriqi')">
                      <el-date-picker v-model="yt.editObj.birthday" type="date" placeholder="选择日期" @change="calculateAge(yt.editObj.birthday)"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7">
                    <el-form-item :label="$t('nianling')">
                      {{ calculateAge(yt.editObj.birthday) }}
                    </el-form-item>
                  </el-col>

                  <el-col :span="3">
                    <el-form-item :label="$t('minzu')">
                      <yi_dictionary_select :max="1" :type="'HR_NATION'" :ids.sync="yt.editObj.nation"> </yi_dictionary_select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <!-- 联系信息 -->
            <el-row>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remake" type="textarea"></el-input>
              </el-form-item>
            </el-row>

            <el-row :span="24">
              <el-col :span="8">
                <el-form-item :label="$t('shoujihao')">
                  <el-input v-model="yt.editObj.callPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('weixinhao')">
                  <el-input v-model="yt.editObj.vxNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Email">
                  <el-input v-model="yt.editObj.emall"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('address')">
              <el-input v-model="yt.editObj.address" type="textarea"></el-input>
            </el-form-item>

            <el-row :span="24">
              <el-col :span="8">
                <el-form-item :label="$t('zaizhizhuangtai')">
                  <el-radio-group v-model="yt.editObj.dtStatus">
                    <el-radio :label="1">在职</el-radio>
                    <el-radio :label="0">离职</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$t('lizhishijian')">
                  <el-date-picker v-model="yt.editObj.leaveTime" type="datetime" placeholder="选择日期时间" :disabled="yt.editObj.dtStatus === 1"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('shifoujinyong')">
                  <el-radio-group v-model="yt.editObj.dtStatus">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="关联账户">
              <yi_data_select :type="'customer_user'" :ids.sync="yt.editObj.userId" :disabled="yt.editObj.dtStatus === 0"></yi_data_select>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="updateData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action === 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import @loading-start="startLoading" @loading-stop="stopLoading" ref="employeeImportTemplate" :templatekey="'employee_import_template'" :uploadApi="'/web/employee/import'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :disabled="importLoading" @click="mainSubImportData" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '人员信息-导入' } }">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>

    <import_excel_skill :show.sync="importShow" />
  </div>
</template>

<script>
import qualificationTable from './qualification';
import certificationTable from './certInfo';
import resourceTable from './resource_table';
import import_excel_skill from './import_excel_skill.vue';
import { utils } from 'xlsx';
export default {
  name: 'web_employment_management_employee_index',
  components: {
    qualificationTable,
    certificationTable,
    resourceTable,
    import_excel_skill
  },
  data() {
    return {
      domain: process.env.NODE_ENV == 'development' ? global.URL_DEV_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false' : process.env.VUE_APP_SERVER == 'preview' ? global.URL_PRE_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false' : global.URL_PROD_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false',
      fileList: [],
      imageUrl: '',
      loading: false,
      activeTab: 'qualification',
      importShow: false,
      columns: [
        {
          label: 'gonghao',
          prop: 'jobNo'
        },
        {
          label: 'xingming',
          prop: 'name'
        },
        {
          label: 'sex',
          prop: 'sex',
          type: 'tag',
          tags: {
            0: {
              color: '#419FFF',
              text: this.$t('女')
            },
            1: {
              color: '#419FFF',
              text: this.$t('男')
            }
          }
        },
        {
          label: 'suosuzuzhi',
          prop: 'org.name'
        },
        {
          label: 'zhiwei',
          prop: 'pos.posName'
        },
        {
          label: 'zaizhizhuangtai',
          prop: 'dtStatus',
          type: 'tag',
          tags: {
            0: {
              color: '#419FFF',
              text: this.$t('离职')
            },
            1: {
              color: '#419FFF',
              text: this.$t('在职')
            }
          }
        },
        {
          label: 'kaoqingzhuangtai',
          prop: 'attendStatus',
          type: 'tag',
          tags: {
            0: {
              color: '#419FFF',
              text: this.$t('buzaiqin')
            },
            1: {
              color: '#419FFF',
              text: this.$t('zaiqing')
            }
          }
        },
        {
          label: 'guanlianzhanghao',
          prop: 'user.nickname'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ],
      qualificationCls: [],
      form: {
        accountOption: 'none',
        workAge: 0,
        age: 0
      },
      initForm: {
        accountOption: 'none',
        workAge: 0,
        age: 0
      },
      detail: {},
      positionList: []
    };
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/employee/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'jobNo';
      this.yt.get(1);
      this.getPositionList();
    }, 300);
  },
  computed: {
    // 获取 token
    headers: function() {
      return { Authorization: window.localStorage.getItem('token') };
    }
  },
  methods: {
    mainSubImportData() {
      let data = [...this.$refs.employeeImportTemplate.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.employeeImportTemplate.listLength == null || this.$refs.employeeImportTemplate.listLength.length == 0) {
        this.mainSubImportLoading = true;
        return this.http
          .post('/web/employee/import?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    syncAllEmployee() {
      this.http
        .get('/custom/weier/employ/syncEmploy')
        .then(res => {
          this.utils.successMessage(this.$t('success'));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    getFile(fileId) {
      this.http.get('/web/customer/files/download', { params: { id: fileId } }).then(res => {
        this.imageUrl = res.data;
      });
    },
    afterShow(e) {
      if (e.photoFile) {
        this.getFile(e.photoFile.id);
      }
    },
    updateData() {
      if (!this.yt.editObj.jobNo) {
        this.utils.errorMessage(this.$t('gonghaobunengweikong'));
        return;
      }
      if (!this.yt.editObj.name) {
        this.utils.errorMessage(this.$t('xingmingbunengweikong'));
        return;
      }
      if (!this.yt.editObj.orgId) {
        this.utils.errorMessage(this.$t('suoshuzuzhibunengweikong'));
        return;
      }

      this.http
        .post('/web/employee/update', this.yt.editObj)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.form = JSON.parse(JSON.stringify(this.initForm));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onchange(file) {
      console.log(file);
      this.file = file.raw;
    },
    beforeUpload(file) {
      if (this.fileList.length >= this.limit) {
        this.utils.errorMessage(this.$t('shuliangyidazuidashangxian'));
        return false;
      }
      if (file.size / 1024 / 1024 > 10) {
        this.utils.errorMessage(this.$t('wenjiandaxiaobunengchaoguo10MB'));
        return false;
      }
      return true;
    },
    // 上传时
    handleOnProgress(event, file, fileList) {
      this.loading = true;
    },
    // 上传成功
    handleOnSuccess(response, file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (response.code !== 200) {
        this.loading = false;
        this.$message.error(response.msg);
        return;
      } else {
        this.form.photoFileId = response.data[0].id;
        this.yt.editObj.photoFileId = response.data[0].id;
      }
      this.loading = false;
    },
    // 上传失败
    handleOnError(error, file, fileList) {
      this.loading = false;
    },

    handleChange(file, fileList) {
      this.fileData.files = fileList;
      console.log(this.fileData);
      //  this.$refs.uploadMutiple.submit();
    }, //查询职位
    getPositionList() {
      this.http.get('web/position/page', { params: { pageSize: 10000 } }).then(res => {
        this.positionList = res.data.rows;
      });
    },
    calculateAge(e) {
      console.log(e);
      //计算到当前时间过了多少年
      let age = this.dayjs().diff(this.dayjs(e), 'year');
      return age;
    },
    calculateWorkAge(e) {
      //计算到当前时间过了多少年
      let age = this.dayjs().diff(this.dayjs(e), 'year');
      return age;
    },
    close() {
      this.imageUrl = '';
      this.yt.isShowEditDialog = false;
      this.form = JSON.parse(JSON.stringify(this.initForm));
    },
    saveData() {
      if (!this.form.jobNo) {
        this.utils.errorMessage(this.$t('gonghaobunengweikong'));
        return;
      }
      if (!this.form.name) {
        this.utils.errorMessage(this.$t('xingmingbunengweikong'));
        return;
      }
      if (!this.form.orgId) {
        this.utils.errorMessage(this.$t('suoshuzuzhibunengweikong'));
        return;
      }
      this.http
        .post('web/employee/create', this.form)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.form = JSON.parse(JSON.stringify(this.initForm));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addRecord() {}
  }
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.form {
  padding: 20px;
  background-color: #fff;
}
.avatar-section {
  text-align: center;
}

.employee-detail {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.detail-info {
  margin-bottom: 20px;
}
.detail-info p {
  margin: 0;
}
.avatar {
  width: 100px;
  height: auto;
  border-radius: 50%;
}
.tab-content {
  margin-top: 10px;
}
</style>
